<template>
  <div class="d-flex ga-5 actions">
    <BaseButton
      v-for="action in actionsArray"
      @click="handleAction(action)"
      :isShowButton="showButton(action)"
      :key="action.id"
      style="width: fit-content"
      paddingTop="7px"
      paddingBottom="7px"
      paddingLeft="10px"
      paddingRight="10px"
      ><div class="d-flex align-center ga-2">
        <v-icon color="white" :icon="action.icon" size="18" /><span
          class="action-key-btn"
          >{{ action.name }}</span
        >
      </div></BaseButton
    >
  </div>
</template>

<script>
import BaseButton from "../BaseButton.vue";
export default {
  components: { BaseButton },
  props: {
    document: {
      type: Object,
    },
    mode: {
      type: String,
      default: "orders",
    },
  },
  methods: {
    showButton(action) {
      if (action.id === 2) {
        if (this?.document?.link) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    handleAction(action) {
      this[action.methodAction]();
    },
    gotoSingelPage() {
      if (this.mode === "orders")
        this.$router.push(`/account/orders/${this.document?.ord}`);
      if (this.mode === "invoices")
        this.$router.push(`/account/invoices/${this.document?.docId}`);
    },
    downloadPdf() {
      if (this?.document?.link) {
        window.open(this.document.link, "_blank");
      }
    },
  },
  computed: {
    actionsArray() {
      return [
        {
          id: 1,
          name: "צפייה",
          icon: "mdi-eye-outline",
          methodAction: "gotoSingelPage",
        },
        {
          id: 2,
          name: "הורדת עותק",
          icon: "mdi-file-download-outline",
          methodAction: "downloadPdf",
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.actions {
  flex: 2;
}
.action-key-btn {
  font-size: $smallTextSize;
  font-weight: 300;
}
</style>
